import React, { FC } from "react";
import eachMinuteOfInterval from "date-fns/eachMinuteOfInterval";
import setMinutes from "date-fns/setMinutes";
import setHours from "date-fns/setHours";
import nb from "date-fns/locale/nb";
import { format } from "date-fns";
import { newDateInOsloTimeZone } from "../Booking/Helpers/timeZoneHelpers";

interface WaitlistTimeSelectProps {
  value: string;
  label: string;
  onChange: (item: string) => void;
  disabled: boolean;
}

export const WaitlistTimeSelect: FC<WaitlistTimeSelectProps> = (props) => {
  const items = eachMinuteOfInterval(
    {
      start: setMinutes(setHours(newDateInOsloTimeZone(), 0), 0),
      end: setMinutes(setHours(newDateInOsloTimeZone(), 23), 59),
    },
    { step: 15 }
  );

  return (
    <p className="fs-6 mb-3">
      <span className="label d-block" id="fromDropdownLabel">
        {props.label}
      </span>
      <select
        className={"form-select form-control mb-0"}
        value={props.value}
        onChange={(value) => {
          props.onChange(value.target.value);
        }}
        disabled={props.disabled}
      >
        {items.map((item, i) => (
          <option key={i} value={format(item, "HH:mm:ss", { locale: nb })}>
            {format(item, "HH:mm", { locale: nb })}
          </option>
        ))}
      </select>
    </p>
  );
};
